export const sweetAlertOptions = {
    confirmButtonColor: '#00c9ff',
    cancelButtonColor: '#ff7674',
    scrollbarPadding: false
};
